const { getOwnPropertyNames: ft, getOwnPropertySymbols: pt } = Object, { hasOwnProperty: dt } = Object.prototype;
function j(n, t) {
  return function(r, s, o) {
    return n(r, s, o) && t(r, s, o);
  };
}
function b(n) {
  return function(e, r, s) {
    if (!e || !r || typeof e != "object" || typeof r != "object")
      return n(e, r, s);
    const { cache: o } = s, a = o.get(e), c = o.get(r);
    if (a && c)
      return a === r && c === e;
    o.set(e, r), o.set(r, e);
    const i = n(e, r, s);
    return o.delete(e), o.delete(r), i;
  };
}
function mt(n) {
  return n?.[Symbol.toStringTag];
}
function H(n) {
  return ft(n).concat(pt(n));
}
const gt = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((n, t) => dt.call(n, t))
);
function P(n, t) {
  return n === t || !n && !t && n !== n && t !== t;
}
const yt = "__v", Et = "__o", At = "_owner", wt = typeof Float16Array < "u", { getOwnPropertyDescriptor: Y, keys: J } = Object;
function _t(n, t) {
  return n.byteLength === t.byteLength && N(new Uint8Array(n), new Uint8Array(t));
}
function Mt(n, t, e) {
  let r = n.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!e.equals(n[r], t[r], r, r, n, t, e))
      return !1;
  return !0;
}
function kt(n, t) {
  return n.byteLength === t.byteLength && N(new Uint8Array(n.buffer, n.byteOffset, n.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength));
}
function xt(n, t) {
  return P(n.getTime(), t.getTime());
}
function Q(n, t, e) {
  return n.name === t.name && n.message === t.message && n.stack === t.stack && e.equals(n.cause, t.cause, "cause", "cause", n, t, e);
}
function Ot(n, t) {
  return n === t;
}
function X(n, t, e) {
  const r = n.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  const s = new Array(r), o = n.entries();
  let a, c, i = 0;
  for (; (a = o.next()) && !a.done; ) {
    const l = t.entries();
    let h = !1, u = 0;
    for (; (c = l.next()) && !c.done; ) {
      if (s[u]) {
        u++;
        continue;
      }
      const d = a.value, g = c.value;
      if (e.equals(d[0], g[0], i, u, n, t, e) && e.equals(d[1], g[1], d[0], g[0], n, t, e)) {
        h = s[u] = !0;
        break;
      }
      u++;
    }
    if (!h)
      return !1;
    i++;
  }
  return !0;
}
const Ct = P;
function tt(n, t, e) {
  const r = J(n);
  let s = r.length;
  if (J(t).length !== s)
    return !1;
  for (; s-- > 0; )
    if (!ct(n, t, e, r[s]))
      return !1;
  return !0;
}
function L(n, t, e) {
  const r = H(n);
  let s = r.length;
  if (H(t).length !== s)
    return !1;
  let o, a, c;
  for (; s-- > 0; )
    if (o = r[s], !ct(n, t, e, o) || (a = Y(n, o), c = Y(t, o), (a || c) && (!a || !c || a.configurable !== c.configurable || a.enumerable !== c.enumerable || a.writable !== c.writable)))
      return !1;
  return !0;
}
function Tt(n, t) {
  return P(n.valueOf(), t.valueOf());
}
function vt(n, t) {
  return n.source === t.source && n.flags === t.flags;
}
function et(n, t, e) {
  const r = n.size;
  if (r !== t.size)
    return !1;
  if (!r)
    return !0;
  const s = new Array(r), o = n.values();
  let a, c;
  for (; (a = o.next()) && !a.done; ) {
    const i = t.values();
    let l = !1, h = 0;
    for (; (c = i.next()) && !c.done; ) {
      if (!s[h] && e.equals(a.value, c.value, a.value, c.value, n, t, e)) {
        l = s[h] = !0;
        break;
      }
      h++;
    }
    if (!l)
      return !1;
  }
  return !0;
}
function N(n, t) {
  let e = n.length;
  if (t.length !== e || n.byteOffset !== t.byteOffset)
    return !1;
  if (n instanceof Float64Array || n instanceof Float32Array || wt && n instanceof Float16Array) {
    for (; e-- > 0; )
      if (n[e] !== t[e] && (n[e] === n[e] || t[e] === t[e]))
        return !1;
    return !0;
  }
  for (; e-- > 0; )
    if (n[e] !== t[e])
      return !1;
  return !0;
}
function It(n, t) {
  return n.href === t.href ? !0 : n.protocol === t.protocol && n.username === t.username && n.password === t.password && n.host === t.host && n.pathname === t.pathname && n.hash === t.hash && Pt(n.searchParams, t.searchParams);
}
function Pt(n, t) {
  const e = n.toString(), r = t.toString();
  return e === r || rt(e) === rt(r);
}
function rt(n) {
  return n.split("&").sort().join("&");
}
function ct(n, t, e, r) {
  return (r === At || r === Et || r === yt) && (n.$$typeof || t.$$typeof) ? !0 : gt(t, r) && e.equals(n[r], t[r], r, r, n, t, e);
}
const St = "[object ArrayBuffer]", Lt = "[object Arguments]", jt = "[object Boolean]", bt = "[object DataView]", Rt = "[object Date]", qt = "[object Error]", Ut = "[object Map]", Ft = "[object Number]", Nt = "[object Object]", Zt = "[object RegExp]", Bt = "[object Set]", Dt = "[object String]", Gt = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, $t = "[object URL]", zt = Object.prototype.toString;
function Vt({ areArrayBuffersEqual: n, areArraysEqual: t, areDataViewsEqual: e, areDatesEqual: r, areErrorsEqual: s, areFunctionsEqual: o, areMapsEqual: a, areNumbersEqual: c, areObjectsEqual: i, arePrimitiveWrappersEqual: l, areRegExpsEqual: h, areSetsEqual: u, areTypedArraysEqual: d, areUrlsEqual: g, unknownTagComparators: y }) {
  return function(f, p, m) {
    if (f === p)
      return !0;
    if (f == null || p == null)
      return !1;
    const M = typeof f;
    if (M !== typeof p)
      return !1;
    if (M !== "object")
      return M === "number" ? c(f, p, m) : M === "function" ? o(f, p, m) : !1;
    const x = f.constructor;
    if (x !== p.constructor)
      return !1;
    if (x === Object)
      return i(f, p, m);
    if (Array.isArray(f))
      return t(f, p, m);
    if (x === Date)
      return r(f, p, m);
    if (x === RegExp)
      return h(f, p, m);
    if (x === Map)
      return a(f, p, m);
    if (x === Set)
      return u(f, p, m);
    const w = zt.call(f);
    if (w === Rt)
      return r(f, p, m);
    if (w === Zt)
      return h(f, p, m);
    if (w === Ut)
      return a(f, p, m);
    if (w === Bt)
      return u(f, p, m);
    if (w === Nt)
      return typeof f.then != "function" && typeof p.then != "function" && i(f, p, m);
    if (w === $t)
      return g(f, p, m);
    if (w === qt)
      return s(f, p, m);
    if (w === Lt)
      return i(f, p, m);
    if (Gt[w])
      return d(f, p, m);
    if (w === St)
      return n(f, p, m);
    if (w === bt)
      return e(f, p, m);
    if (w === jt || w === Ft || w === Dt)
      return l(f, p, m);
    if (y) {
      let S = y[w];
      if (!S) {
        const k = mt(f);
        k && (S = y[k]);
      }
      if (S)
        return S(f, p, m);
    }
    return !1;
  };
}
function Kt({ circular: n, createCustomConfig: t, strict: e }) {
  let r = {
    areArrayBuffersEqual: _t,
    areArraysEqual: e ? L : Mt,
    areDataViewsEqual: kt,
    areDatesEqual: xt,
    // `Error` subclasses routinely carry their own enumerable properties (`status`, `code`, ...),
    // which the error comparator alone does not see, so it is composed with the object comparator.
    // `name` / `message` / `stack` are own but not enumerable, which is why errors need a
    // comparator of their own rather than being treated as plain objects in the first place.
    areErrorsEqual: e ? j(Q, L) : j(Q, tt),
    areFunctionsEqual: Ot,
    areMapsEqual: e ? j(X, L) : X,
    areNumbersEqual: Ct,
    areObjectsEqual: e ? L : tt,
    arePrimitiveWrappersEqual: Tt,
    areRegExpsEqual: vt,
    areSetsEqual: e ? j(et, L) : et,
    areTypedArraysEqual: e ? j(N, L) : N,
    areUrlsEqual: It,
    unknownTagComparators: void 0
  };
  if (t && (r = Object.assign({}, r, t(r))), n) {
    const s = b(r.areArraysEqual), o = b(r.areErrorsEqual), a = b(r.areMapsEqual), c = b(r.areObjectsEqual), i = b(r.areSetsEqual);
    r = Object.assign({}, r, {
      areArraysEqual: s,
      areErrorsEqual: o,
      areMapsEqual: a,
      areObjectsEqual: c,
      areSetsEqual: i
    });
  }
  return r;
}
function Wt(n) {
  return function(t, e, r, s, o, a, c) {
    return n(t, e, c);
  };
}
function Ht({ circular: n, comparator: t, createState: e, equals: r, strict: s }) {
  if (e)
    return function(c, i) {
      const { cache: l = n ? /* @__PURE__ */ new WeakMap() : void 0, meta: h } = e();
      return t(c, i, {
        cache: l,
        equals: r,
        meta: h,
        strict: s
      });
    };
  if (n)
    return function(c, i) {
      return t(c, i, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: r,
        meta: void 0,
        strict: s
      });
    };
  const o = {
    cache: void 0,
    equals: r,
    meta: void 0,
    strict: s
  };
  return function(c, i) {
    return t(c, i, o);
  };
}
const nt = T();
T({ strict: !0 });
T({ circular: !0 });
T({
  circular: !0,
  strict: !0
});
T({
  createInternalComparator: () => P
});
T({
  strict: !0,
  createInternalComparator: () => P
});
T({
  circular: !0,
  createInternalComparator: () => P
});
T({
  circular: !0,
  createInternalComparator: () => P,
  strict: !0
});
function T(n = {}) {
  const { circular: t = !1, createInternalComparator: e, createState: r, strict: s = !1 } = n, o = Kt(n), a = Vt(o), c = e ? e(a) : Wt(a);
  return Ht({ circular: t, comparator: a, createState: r, equals: c, strict: s });
}
const st = [
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
], Z = 1, R = 8, E = new Uint32Array(96);
class V {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBufferLike} data
   */
  static from(t) {
    if (!t || t.byteLength === void 0 || t.buffer)
      throw new Error("Data must be an instance of ArrayBuffer or SharedArrayBuffer.");
    const [e, r] = new Uint8Array(t, 0, 2);
    if (e !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    const s = r >> 4;
    if (s !== Z)
      throw new Error(`Got v${s} data when expected v${Z}.`);
    const o = st[r & 15];
    if (!o)
      throw new Error("Unrecognized array type.");
    const [a] = new Uint16Array(t, 2, 1), [c] = new Uint32Array(t, 4, 1);
    return new V(c, a, o, void 0, t);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBufferConstructor | SharedArrayBufferConstructor} [ArrayBufferType=ArrayBuffer] The array buffer type used for storage (`ArrayBuffer` by default).
   * @param {ArrayBufferLike} [data] (For internal use only)
   */
  constructor(t, e = 64, r = Float64Array, s = ArrayBuffer, o) {
    if (isNaN(t) || t < 0) throw new Error(`Unexpected numItems value: ${t}.`);
    this.numItems = +t, this.nodeSize = Math.min(Math.max(+e, 2), 65535), this.ArrayType = r, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
    const a = st.indexOf(this.ArrayType), c = t * 2 * this.ArrayType.BYTES_PER_ELEMENT, i = t * this.IndexArrayType.BYTES_PER_ELEMENT, l = (8 - i % 8) % 8;
    if (a < 0)
      throw new Error(`Unexpected typed array class: ${r}.`);
    if (o)
      this.data = o, this.ids = new this.IndexArrayType(o, R, t), this.coords = new r(o, R + i + l, t * 2), this._pos = t * 2, this._finished = !0;
    else {
      const h = this.data = new s(R + c + i + l);
      this.ids = new this.IndexArrayType(h, R, t), this.coords = new r(h, R + i + l, t * 2), this._pos = 0, this._finished = !1, new Uint8Array(h, 0, 2).set([219, (Z << 4) + a]), new Uint16Array(h, 2, 1)[0] = e, new Uint32Array(h, 4, 1)[0] = t;
    }
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(t, e) {
    const r = this._pos >> 1;
    return this.ids[r] = r, this.coords[this._pos++] = t, this.coords[this._pos++] = e, r;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    const t = this._pos >> 1;
    if (t !== this.numItems)
      throw new Error(`Added ${t} items when expected ${this.numItems}.`);
    return G(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(t, e, r, s) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: o, coords: a, nodeSize: c } = this;
    E[0] = 0, E[1] = o.length - 1, E[2] = 0;
    let i = 3;
    const l = [];
    for (; i > 0; ) {
      const h = E[--i], u = E[--i], d = E[--i];
      if (u - d <= c) {
        for (let f = d; f <= u; f++) {
          const p = a[2 * f], m = a[2 * f + 1];
          p >= t && p <= r && m >= e && m <= s && l.push(o[f]);
        }
        continue;
      }
      const g = d + u >> 1, y = a[2 * g], A = a[2 * g + 1];
      y >= t && y <= r && A >= e && A <= s && l.push(o[g]), (h === 0 ? t <= y : e <= A) && (E[i++] = d, E[i++] = g - 1, E[i++] = 1 - h), (h === 0 ? r >= y : s >= A) && (E[i++] = g + 1, E[i++] = u, E[i++] = 1 - h);
    }
    return l;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(t, e, r) {
    const s = (
      /** @type {number[]} */
      []
    );
    return this.withinInto(t, e, r, s), s;
  }
  /**
   * Search the index for items within a given radius, writing matching ids into `out`
   * via indexed assignment (`out[i] = id`). Accepts any indexed-writable container —
   * a typed array sized to the expected upper bound (allocation-free, fast) or a plain
   * `Array` (which will grow as needed). Returns the number of matches written.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @param {number[] | TypedArray} out Container to write matching ids into.
   * @returns {number} The number of matches written to `out`.
   */
  withinInto(t, e, r, s) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: o, coords: a, nodeSize: c } = this;
    E[0] = 0, E[1] = o.length - 1, E[2] = 0;
    let i = 3, l = 0;
    const h = r * r;
    for (; i > 0; ) {
      const u = E[--i], d = E[--i], g = E[--i];
      if (d - g <= c) {
        for (let p = g; p <= d; p++)
          it(a[2 * p], a[2 * p + 1], t, e) <= h && (s[l++] = o[p]);
        continue;
      }
      const y = g + d >> 1, A = a[2 * y], f = a[2 * y + 1];
      it(A, f, t, e) <= h && (s[l++] = o[y]), (u === 0 ? t - r <= A : e - r <= f) && (E[i++] = g, E[i++] = y - 1, E[i++] = 1 - u), (u === 0 ? t + r >= A : e + r >= f) && (E[i++] = y + 1, E[i++] = d, E[i++] = 1 - u);
    }
    return l;
  }
}
function G(n, t, e, r, s, o) {
  if (s - r <= e) return;
  const a = r + s >> 1;
  ut(n, t, a, r, s, o), G(n, t, e, r, a - 1, 1 - o), G(n, t, e, a + 1, s, 1 - o);
}
function ut(n, t, e, r, s, o) {
  for (; s > r; ) {
    if (s - r > 600) {
      const l = s - r + 1, h = e - r + 1, u = Math.log(l), d = 0.5 * Math.exp(2 * u / 3), g = 0.5 * Math.sqrt(u * d * (l - d) / l) * (h - l / 2 < 0 ? -1 : 1), y = Math.max(r, Math.floor(e - h * d / l + g)), A = Math.min(s, Math.floor(e + (l - h) * d / l + g));
      ut(n, t, e, y, A, o);
    }
    const a = t[2 * e + o];
    let c = r, i = s;
    for (q(n, t, r, e), t[2 * s + o] > a && q(n, t, r, s); c < i; ) {
      for (q(n, t, c, i), c++, i--; t[2 * c + o] < a; ) c++;
      for (; t[2 * i + o] > a; ) i--;
    }
    t[2 * r + o] === a ? q(n, t, r, i) : (i++, q(n, t, i, s)), i <= e && (r = i + 1), e <= i && (s = i - 1);
  }
}
function q(n, t, e, r) {
  B(n, e, r), B(t, 2 * e, 2 * r), B(t, 2 * e + 1, 2 * r + 1);
}
function B(n, t, e) {
  const r = n[t];
  n[t] = n[e], n[e] = r;
}
function it(n, t, e, r) {
  const s = n - e, o = t - r;
  return s * s + o * o;
}
const Yt = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (n) => n
  // props => ({sum: props.my_value})
}, ot = Math.fround || /* @__PURE__ */ ((n) => ((t) => (n[0] = +t, n[0])))(new Float32Array(1)), v = 2, C = 3, D = 4, O = 5, lt = 6;
class Jt {
  constructor(t) {
    this.options = Object.assign(Object.create(Yt), t), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(t) {
    const { log: e, minZoom: r, maxZoom: s } = this.options;
    e && console.time("total time");
    const o = `prepare ${t.length} points`;
    e && console.time(o), this.points = t;
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const l = t[i];
      if (!l.geometry) continue;
      const [h, u] = l.geometry.coordinates, d = ot(U(h)), g = ot(F(u));
      a.push(
        d,
        g,
        // projected point coordinates
        1 / 0,
        // the last zoom the point was processed at
        i,
        // index of the source feature in the original input array
        -1,
        // parent cluster id
        1
        // number of points in a cluster
      ), this.options.reduce && a.push(0);
    }
    let c = this.trees[s + 1] = this._createTree(a);
    e && console.timeEnd(o);
    for (let i = s; i >= r; i--) {
      const l = +Date.now();
      c = this.trees[i] = this._createTree(this._cluster(c, i)), e && console.log("z%d: %d clusters in %dms", i, c.numItems, +Date.now() - l);
    }
    return e && console.timeEnd("total time"), this;
  }
  getClusters(t, e) {
    let r = ((t[0] + 180) % 360 + 360) % 360 - 180;
    const s = Math.max(-90, Math.min(90, t[1]));
    let o = t[2] === 180 ? 180 : ((t[2] + 180) % 360 + 360) % 360 - 180;
    const a = Math.max(-90, Math.min(90, t[3]));
    if (t[2] - t[0] >= 360)
      r = -180, o = 180;
    else if (r > o) {
      const u = this.getClusters([r, s, 180, a], e), d = this.getClusters([-180, s, o, a], e);
      return u.concat(d);
    }
    const c = this.trees[this._limitZoom(e)], i = c.range(U(r), F(a), U(o), F(s)), l = c.data, h = [];
    for (const u of i) {
      const d = this.stride * u;
      h.push(l[d + O] > 1 ? at(l, d, this.clusterProps) : this.points[l[d + C]]);
    }
    return h;
  }
  getChildren(t) {
    const e = this._getOriginId(t), r = this._getOriginZoom(t), s = "No cluster with the specified id.", o = this.trees[r];
    if (!o) throw new Error(s);
    const a = o.data;
    if (e * this.stride >= a.length) throw new Error(s);
    const c = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), i = a[e * this.stride], l = a[e * this.stride + 1], h = o.within(i, l, c), u = [];
    for (const d of h) {
      const g = d * this.stride;
      a[g + D] === t && u.push(a[g + O] > 1 ? at(a, g, this.clusterProps) : this.points[a[g + C]]);
    }
    if (u.length === 0) throw new Error(s);
    return u;
  }
  getLeaves(t, e, r) {
    e = e || 10, r = r || 0;
    const s = [];
    return this._appendLeaves(s, t, e, r, 0), s;
  }
  getTile(t, e, r) {
    const s = this.trees[this._limitZoom(t)], o = Math.pow(2, t), { extent: a, radius: c } = this.options, i = c / a, l = (r - i) / o, h = (r + 1 + i) / o, u = {
      features: []
    };
    return this._addTileFeatures(
      s.range((e - i) / o, l, (e + 1 + i) / o, h),
      s.data,
      e,
      r,
      o,
      u
    ), e === 0 && this._addTileFeatures(
      s.range(1 - i / o, l, 1, h),
      s.data,
      o,
      r,
      o,
      u
    ), e === o - 1 && this._addTileFeatures(
      s.range(0, l, i / o, h),
      s.data,
      -1,
      r,
      o,
      u
    ), u.features.length ? u : null;
  }
  getClusterExpansionZoom(t) {
    let e = this._getOriginZoom(t) - 1;
    for (; e <= this.options.maxZoom; ) {
      const r = this.getChildren(t);
      if (e++, r.length !== 1) break;
      t = r[0].properties.cluster_id;
    }
    return e;
  }
  _appendLeaves(t, e, r, s, o) {
    const a = this.getChildren(e);
    for (const c of a) {
      const i = c.properties;
      if (i && i.cluster ? o + i.point_count <= s ? o += i.point_count : o = this._appendLeaves(t, i.cluster_id, r, s, o) : o < s ? o++ : t.push(c), t.length === r) break;
    }
    return o;
  }
  _createTree(t) {
    const e = new V(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
    for (let r = 0; r < t.length; r += this.stride) e.add(t[r], t[r + 1]);
    return e.finish(), e.data = t, e;
  }
  _addTileFeatures(t, e, r, s, o, a) {
    for (const c of t) {
      const i = c * this.stride, l = e[i + O] > 1;
      let h, u, d;
      if (l)
        h = ht(e, i, this.clusterProps), u = e[i], d = e[i + 1];
      else {
        const A = this.points[e[i + C]];
        h = A.properties;
        const [f, p] = A.geometry.coordinates;
        u = U(f), d = F(p);
      }
      const g = {
        type: 1,
        geometry: [[
          Math.round(this.options.extent * (u * o - r)),
          Math.round(this.options.extent * (d * o - s))
        ]],
        tags: h
      };
      let y;
      l || this.options.generateId ? y = e[i + C] : y = this.points[e[i + C]].id, y !== void 0 && (g.id = y), a.features.push(g);
    }
  }
  _limitZoom(t) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+t), this.options.maxZoom + 1));
  }
  _cluster(t, e) {
    const { radius: r, extent: s, reduce: o, minPoints: a } = this.options, c = r / (s * Math.pow(2, e)), i = t.data, l = [], h = this.stride;
    for (let u = 0; u < i.length; u += h) {
      if (i[u + v] <= e) continue;
      i[u + v] = e;
      const d = i[u], g = i[u + 1], y = t.within(i[u], i[u + 1], c), A = i[u + O];
      let f = A;
      for (const p of y) {
        const m = p * h;
        i[m + v] > e && (f += i[m + O]);
      }
      if (f > A && f >= a) {
        let p = d * A, m = g * A, M, x = -1;
        const w = ((u / h | 0) << 5) + (e + 1) + this.points.length;
        for (const S of y) {
          const k = S * h;
          if (i[k + v] <= e) continue;
          i[k + v] = e;
          const W = i[k + O];
          p += i[k] * W, m += i[k + 1] * W, i[k + D] = w, o && (M || (M = this._map(i, u, !0), x = this.clusterProps.length, this.clusterProps.push(M)), o(M, this._map(i, k)));
        }
        i[u + D] = w, l.push(p / f, m / f, 1 / 0, w, -1, f), o && l.push(x);
      } else {
        for (let p = 0; p < h; p++) l.push(i[u + p]);
        if (f > 1)
          for (const p of y) {
            const m = p * h;
            if (!(i[m + v] <= e)) {
              i[m + v] = e;
              for (let M = 0; M < h; M++) l.push(i[m + M]);
            }
          }
      }
    }
    return l;
  }
  // get index of the point from which the cluster originated
  _getOriginId(t) {
    return t - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(t) {
    return (t - this.points.length) % 32;
  }
  _map(t, e, r) {
    if (t[e + O] > 1) {
      const a = this.clusterProps[t[e + lt]];
      return r ? Object.assign({}, a) : a;
    }
    const s = this.points[t[e + C]].properties, o = this.options.map(s);
    return r && o === s ? Object.assign({}, o) : o;
  }
}
function at(n, t, e) {
  return {
    type: "Feature",
    id: n[t + C],
    properties: ht(n, t, e),
    geometry: {
      type: "Point",
      coordinates: [Qt(n[t]), Xt(n[t + 1])]
    }
  };
}
function ht(n, t, e) {
  const r = n[t + O], s = r >= 1e4 ? `${Math.round(r / 1e3)}k` : r >= 1e3 ? `${Math.round(r / 100) / 10}k` : r, o = n[t + lt], a = o === -1 ? {} : Object.assign({}, e[o]);
  return Object.assign(a, {
    cluster: !0,
    cluster_id: n[t + C],
    point_count: r,
    point_count_abbreviated: s
  });
}
function U(n) {
  return n / 360 + 0.5;
}
function F(n) {
  const t = Math.sin(n * Math.PI / 180), e = 0.5 - 0.25 * Math.log((1 + t) / (1 - t)) / Math.PI;
  return e < 0 ? 0 : e > 1 ? 1 : e;
}
function Qt(n) {
  return (n - 0.5) * 360;
}
function Xt(n) {
  const t = (180 - n * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
function te(n, t) {
  var e = {};
  for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && t.indexOf(r) < 0 && (e[r] = n[r]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, r = Object.getOwnPropertySymbols(n); s < r.length; s++)
      t.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[s]) && (e[r[s]] = n[r[s]]);
  return e;
}
class _ {
  static isAdvancedMarkerAvailable(t) {
    return google.maps.marker && t.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(t) {
    return google.maps.marker && t instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(t, e) {
    this.isAdvancedMarker(t) ? t.map = e : t.setMap(e);
  }
  static getPosition(t) {
    if (this.isAdvancedMarker(t)) {
      if (t.position) {
        if (t.position instanceof google.maps.LatLng)
          return t.position;
        if (Number.isFinite(t.position.lat) && Number.isFinite(t.position.lng))
          return new google.maps.LatLng(t.position.lat, t.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return t.getPosition();
  }
  static getVisible(t) {
    return this.isAdvancedMarker(t) ? !0 : t.getVisible();
  }
}
class $ {
  constructor({ markers: t, position: e }) {
    this.markers = [], t && (this.markers = t), e && (e instanceof google.maps.LatLng ? this._position = e : this._position = new google.maps.LatLng(e));
  }
  get bounds() {
    if (this.markers.length === 0 && !this._position)
      return;
    const t = new google.maps.LatLngBounds(this._position, this._position);
    for (const e of this.markers)
      t.extend(_.getPosition(e));
    return t;
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((t) => _.getVisible(t)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(t) {
    this.markers.push(t);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (_.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
function z(n, t = "assertion failed") {
  if (n == null)
    throw Error(t);
}
class ee {
  constructor({ maxZoom: t = 16 }) {
    this.maxZoom = t;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop({ markers: t }) {
    return re(t);
  }
}
const re = (n) => n.map((e) => new $({
  position: _.getPosition(e),
  markers: [e]
}));
class ne extends ee {
  constructor(t) {
    var { maxZoom: e, radius: r = 60 } = t, s = te(t, ["maxZoom", "radius"]);
    super({ maxZoom: e }), this.markers = [], this.clusters = [], this.state = { zoom: -1 }, this.superCluster = new Jt(Object.assign({ maxZoom: this.maxZoom, radius: r }, s));
  }
  calculate(t) {
    let e = !1, r = t.map.getZoom();
    z(r), r = Math.round(r);
    const s = { zoom: r };
    if (!nt(t.markers, this.markers)) {
      e = !0, this.markers = [...t.markers];
      const o = this.markers.map((a) => {
        const c = _.getPosition(a);
        return {
          type: "Feature",
          geometry: { type: "Point", coordinates: [c.lng(), c.lat()] },
          properties: { marker: a }
        };
      });
      this.superCluster.load(o);
    }
    return e || (this.state.zoom <= this.maxZoom || s.zoom <= this.maxZoom) && (e = !nt(this.state, s)), this.state = s, t.markers.length === 0 ? (this.clusters = [], { clusters: this.clusters, changed: e }) : (e && (this.clusters = this.cluster(t)), { clusters: this.clusters, changed: e });
  }
  cluster({ map: t }) {
    const e = t.getZoom();
    return z(e), this.superCluster.getClusters([-180, -90, 180, 90], Math.round(e)).map((r) => this.transformCluster(r));
  }
  transformCluster({ geometry: { coordinates: [t, e] }, properties: r }) {
    if (r.cluster)
      return new $({
        markers: this.superCluster.getLeaves(r.cluster_id, 1 / 0).map((o) => o.properties.marker),
        position: { lat: e, lng: t }
      });
    const s = r.marker;
    return new $({
      markers: [s],
      position: _.getPosition(s)
    });
  }
}
class se {
  constructor(t, e) {
    this.markers = { sum: t.length };
    const r = e.map((o) => o.count), s = r.reduce((o, a) => o + a, 0);
    this.clusters = {
      count: e.length,
      markers: {
        mean: s / e.length,
        sum: s,
        min: Math.min(...r),
        max: Math.max(...r)
      }
    };
  }
}
class ie {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render({ count: t, position: e }, r, s) {
    const a = `<svg fill="${t > Math.max(10, r.clusters.markers.mean) ? "#ff0000" : "#0000ff"}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${t}</text>
</svg>`, c = `Cluster of ${t} markers`, i = Number(google.maps.Marker.MAX_ZINDEX) + t;
    if (_.isAdvancedMarkerAvailable(s)) {
      const u = new DOMParser().parseFromString(a, "image/svg+xml").documentElement;
      u.setAttribute("transform", "translate(0 25)");
      const d = {
        map: s,
        position: e,
        zIndex: i,
        title: c,
        content: u
      };
      return new google.maps.marker.AdvancedMarkerElement(d);
    }
    const l = {
      position: e,
      zIndex: i,
      title: c,
      icon: {
        url: `data:image/svg+xml;base64,${btoa(a)}`,
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(l);
  }
}
function oe(n, t) {
  for (let e in t.prototype)
    n.prototype[e] = t.prototype[e];
}
class K {
  constructor() {
    oe(K, google.maps.OverlayView);
  }
}
var I;
(function(n) {
  n.CLUSTERING_BEGIN = "clusteringbegin", n.CLUSTERING_END = "clusteringend", n.CLUSTER_CLICK = "click", n.GMP_CLICK = "gmp-click";
})(I || (I = {}));
const ae = (n, t, e) => {
  t.bounds && e.fitBounds(t.bounds);
};
class ce extends K {
  constructor({ map: t, markers: e = [], algorithmOptions: r = {}, algorithm: s = new ne(r), renderer: o = new ie(), onClusterClick: a = ae }) {
    super(), this.map = null, this.idleListener = null, this.markers = [...e], this.clusters = [], this.algorithm = s, this.renderer = o, this.onClusterClick = a, t && this.setMap(t);
  }
  addMarker(t, e) {
    this.markers.includes(t) || (this.markers.push(t), e || this.render());
  }
  addMarkers(t, e) {
    t.forEach((r) => {
      this.addMarker(r, !0);
    }), e || this.render();
  }
  removeMarker(t, e) {
    const r = this.markers.indexOf(t);
    return r === -1 ? !1 : (_.setMap(t, null), this.markers.splice(r, 1), e || this.render(), !0);
  }
  removeMarkers(t, e) {
    let r = !1;
    return t.forEach((s) => {
      r = this.removeMarker(s, !0) || r;
    }), r && !e && this.render(), r;
  }
  clearMarkers(t) {
    this.markers.length = 0, t || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    const t = this.getMap();
    if (t instanceof google.maps.Map && t.getProjection()) {
      google.maps.event.trigger(this, I.CLUSTERING_BEGIN, this);
      const { clusters: e, changed: r } = this.algorithm.calculate({
        markers: this.markers,
        map: t,
        mapCanvasProjection: this.getProjection()
      });
      if (r || r == null) {
        const s = /* @__PURE__ */ new Set();
        for (const a of e)
          a.markers.length == 1 && s.add(a.markers[0]);
        const o = [];
        for (const a of this.clusters)
          a.marker != null && (a.markers.length == 1 ? s.has(a.marker) || _.setMap(a.marker, null) : o.push(a.marker));
        this.clusters = e, this.renderClusters(), requestAnimationFrame(() => o.forEach((a) => _.setMap(a, null)));
      }
      google.maps.event.trigger(this, I.CLUSTERING_END, this);
    }
  }
  onAdd() {
    const t = this.getMap();
    z(t), this.idleListener = t.addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    this.idleListener && google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((t) => _.setMap(t, null)), this.clusters.forEach((t) => t.delete()), this.clusters = [];
  }
  renderClusters() {
    const t = new se(this.markers, this.clusters), e = this.getMap();
    this.clusters.forEach((r) => {
      if (r.markers.length === 1)
        r.marker = r.markers[0];
      else if (r.marker = this.renderer.render(r, t, e), r.markers.forEach((s) => _.setMap(s, null)), this.onClusterClick) {
        const s = _.isAdvancedMarker(r.marker) ? I.GMP_CLICK : I.CLUSTER_CLICK;
        r.marker.addListener(
          s,
          /* istanbul ignore next */
          (o) => {
            google.maps.event.trigger(this, I.CLUSTER_CLICK, r), this.onClusterClick(o, r, e);
          }
        );
      }
      _.setMap(r.marker, e);
    });
  }
}
export {
  ce as M
};
